import { render, staticRenderFns } from "./PostAttachments.vue?vue&type=template&id=33dfd795&scoped=true&"
import script from "./PostAttachments.vue?vue&type=script&lang=js&"
export * from "./PostAttachments.vue?vue&type=script&lang=js&"
import style0 from "./PostAttachments.vue?vue&type=style&index=0&id=33dfd795&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dfd795",
  null
  
)

export default component.exports